import { Component, Input, OnInit } from '@angular/core';
import { ApiService } from 'src/app/shared/service/api.service';

@Component({
  selector: 'app-selling-goals',
  templateUrl: './selling-goals.component.html',
  styleUrls: ['./selling-goals.component.css']
})
export class SellingGoalsComponent implements OnInit {
  _filterAccomplish: any = {};
  @Input() set filterAccomplish(value: any) {
    this._filterAccomplish = value;
    this.filterItem(this._filterAccomplish);
  }

  dataItem = {
    chart: {
      lowerlimit: "0",
      upperlimit: "10000000",
      showvalue: "1",
      theme: "fusion",
      decimalSeparator: ",",
      thousandSeparator: "."
    },
    colorrange: {
      color: [
        {
          minvalue: "0",
          maxvalue: "2500000",
          code: "#F2726F"
        },
        {
          minvalue: "2500000",
          maxvalue: "5000000",
          code: "#FF9B05"
        },
        {
          minvalue: "5000000",
          maxvalue: "7500000",
          code: "#FFC533"
        },
        {
          minvalue: "7500000",
          maxvalue: "10000000",
          code: "#62B58F"
        }
      ]
    },
    dials: {
      dial: [
        {
          value: "71",
          tooltext: "<b>9%</b>"
        }
      ]
    },
    // trendpoints: {
    //   point: [
    //     {
    //       startvalue: "8000000",
    //       displayvalue: "Meta 8M",
    //       thickness: "2",
    //       color: "#E15A26",
    //       usemarker: "1",
    //       markerbordercolor: "#E15A26",
    //       markertooltext: "80%"
    //     }
    //   ]
    // }
  };

  width = 600;
  height = 400;
  type = "angulargauge";
  dataFormat = "json";
  dataSource = this.dataItem;
  loading: boolean = true;
  errorApi = false;
  dateFirst!: any;

  constructor(private api: ApiService) {
  }

  ngOnInit() {
    let date = new Date();
    this.dateFirst = date.toISOString().slice(0, 10);
    setTimeout(() => {
      let objFilter = {
        dataMin: this.dateFirst + ' 00:00:00',
        dataMax: this.dateFirst + ' 23:59:59',
        branch: [1],
        target_name: 'META',
        sellers: []
      }
      this.targetSale(objFilter);
    }, 1000);
  }

  filterItem(item: any) {
    this.errorApi = false;
    this.loading = true;
    this.targetSale(item);
  }

  async targetSale(item: any) {
    // await this.api.postSaleTarget(item.dataMin, item.dataMax, item.branch, 'META', item.sellers).subscribe((data: any) => {
    //   try {
    //     this.dataItem.dials.dial[0].value = "";
    //     this.dataItem.dials.dial[0].value = data.dataRow[0].total_sale_value;
    //     this.loading = false;
    //     this.errorApi = false;
    //   } catch(ex:unknown) {
    //     this.loading = false;
    //     if (ex instanceof Error)
    //       console.log(ex.message);
    //   }
    // }, error => {
    //   this.loading = false;
    //   this.errorApi = true;
    // });
  }

}
